'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ContextualMenu = require('../../structures/ContextualMenu');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactionsRowAddButton = function (_React$PureComponent) {
    (0, _inherits3.default)(ReactionsRowAddButton, _React$PureComponent);

    function ReactionsRowAddButton(props) {
        (0, _classCallCheck3.default)(this, ReactionsRowAddButton);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ReactionsRowAddButton.__proto__ || (0, _getPrototypeOf2.default)(ReactionsRowAddButton)).call(this, props));

        _this.getMenuOptions = function (ev) {
            var menuOptions = {};
            var gutter = 10;
            var emojiPickerWidth = _this.popoverWidth + gutter;

            var buttonRect = ev.target.getBoundingClientRect();
            // The window X and Y offsets are to adjust position when zoomed in to page
            var buttonLeft = buttonRect.left + window.pageXOffset;
            var buttonBottom = buttonRect.bottom + window.pageYOffset;
            var buttonTop = buttonRect.top + window.pageYOffset;
            // Align the right edge of the menu to the right edge of the button
            menuOptions.left = buttonLeft + gutter;
            if (menuOptions.left + emojiPickerWidth > window.innerWidth) {
                menuOptions.left = window.innerWidth - emojiPickerWidth - gutter;
            }
            // Align the menu vertically on whichever side of the button has more
            // space available.
            if (buttonBottom < window.innerHeight / 2) {
                menuOptions.top = buttonBottom + gutter;
            } else {
                menuOptions.bottom = window.innerHeight - buttonTop + gutter;
            }
            return menuOptions;
        };

        _this.onClick = function (ev) {
            var ReactionPicker = _index2.default.getComponent('emojipicker.ReactionPicker');

            var menuOptions = (0, _extends3.default)({}, _this.getMenuOptions(ev), {
                mxEvent: _this.props.mxEvent,
                reactions: _this.props.reactions,
                theme: _this.props.theme,
                chevronFace: "none"
            });

            (0, _ContextualMenu.createMenu)(ReactionPicker, menuOptions);
        };

        _this.popoverWidth = props.width || 311;
        _this.popoverHeight = props.height || 408;
        return _this;
    }

    (0, _createClass3.default)(ReactionsRowAddButton, [{
        key: 'render',
        value: function render() {
            var classes = (0, _classnames2.default)({
                mx_ReactionsRowButton: true,
                mx_ReactionsRowAddButton: true
            });

            return _react2.default.createElement('span', { className: classes,
                onClick: this.onClick
            });
        }
    }]);
    return ReactionsRowAddButton;
}(_react2.default.PureComponent); /*
                                  Copyright 2019 New Vector Ltd
                                  
                                  Licensed under the Apache License, Version 2.0 (the "License");
                                  you may not use this file except in compliance with the License.
                                  You may obtain a copy of the License at
                                  
                                      http://www.apache.org/licenses/LICENSE-2.0
                                  
                                  Unless required by applicable law or agreed to in writing, software
                                  distributed under the License is distributed on an "AS IS" BASIS,
                                  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                  See the License for the specific language governing permissions and
                                  limitations under the License.
                                  */

ReactionsRowAddButton.propTypes = {
    // The event we're displaying reactions for
    mxEvent: _propTypes2.default.object.isRequired,
    // A Set of Martix reaction events for this key
    reactions: _propTypes2.default.object.isRequired
};
exports.default = ReactionsRowAddButton;
module.exports = exports['default'];
//# sourceMappingURL=ReactionsRowAddButton.js.map